import {authorFromTypeToTitle} from '@/data/pl/authorFromTypeToTitle';

import blogpost_data from '@/data/blog-post.data';

const activityMapping = {
  reviewedBy: 'reviewedOn',
  updatedBy: 'editedOn',
  factChecker: 'factCheckedOn'
};

const parseActivityDate = (data, role, locale) => {
  locale = 'pl';

  return {
    label: authorFromTypeToTitle[locale][role],
    date: data[activityMapping[role]],
    datetime: data[`${activityMapping[role]}Datetime`]
  };
};

const getActivityDatesArray = (data, rolesOrder, locale) => {
  return rolesOrder.map(role => parseActivityDate(data, role, locale)).filter(dateObj => dateObj.date && dateObj.datetime);
};

export const getActivityDates = (data, rolesOrder, locale) => {
  return {
    updatedAt: {
      label: blogpost_data?.[locale]?.updatedAtLabel ?? "",
      date: {
        string: data.updatedAtCustom,
        iso: data.updatedAtDatetime
      }
    }
  };
};
